<template>
    <div>
        <!-- display files in dialog table -->
        <v-data-table scroll-region
                      id="documents_table"
                      :headers="headers"
                      :items="items"
                      :items-per-page="8"
                      :search="search"
                      :options.sync="options"
                      :server-items-length="serverItemsLength"
                      :loading="loading"
                      class="flat mt-5"
                      :multi-sort="true"
                      :footer-props="{showFirstLastPage: true}"
                      :hide-default-footer="hideDefaultFooter"
                      v-scroll="debouncedScroll"
        >
            <template v-slot:header.action="{ header }">
                <v-dialog
                    v-model="dialog"
                    width="500"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            text
                        >
                            Add Files
                        </v-btn>
                    </template>

                    <v-card>
                        <v-card-title class="text-h5 primary text-white">
                            File Upload
                        </v-card-title>

                        <v-card-text>
                            <div class="file-uploader">
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-file-input
                                                v-model="files"
                                                chips
                                                counter
                                                label="File input"
                                                multiple
                                                placeholder="Select your files"
                                                prepend-icon="mdi-paperclip"
                                                outlined
                                                :show-size="1000"
                                                dense
                                            ></v-file-input>
                                        </v-col>
                                    </v-row>
                                </v-container>



                            </div>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="cancel"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="submit"
                            >
                                Submit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:item.file_name="{ item }">
                <a :href="item.file_url" target="_blank">{{item.file_name}}</a>
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn icon @click.prevent.stop="askShouldWeDeleteDocument(item.id)">
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </template>
        </v-data-table>

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { VDataTable } from '@/Mixins/VDataTableMixin'
import FileUploadModal from "@/Modals/FileUploadModal";
import bus from '@/bus'

export default {
    name: "FileUploadIndex",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        FileUploadModal
    },
    mixins: [VDataTable],
    data() {
        return {
            items: this.input || [],                    // An array of data.  Each element represents one row to be drawn into the data table
            endpoint_uri: '/getDocuments',          // The URI for retrieving records for the list
            endpoint_method: 'POST',
            title: 'Documents',
            infiniteScroll: false,
            files: [],
            dialog: false,
        }
    },
    methods: {
        deleteFile(id) {
            axios.delete('/documents/' + id).
            then(response => {
                this.getData()
                this.$root.snackbar.success('File deleted')
            }).
            catch(error => {
                //this.message = error.message
                this.$root.snackbar.error('Could not delete file')
            });

        },
        async askShouldWeDeleteDocument(document_id) {
            if (
                await this.$root.confirm.open(
                    'Confirm',
                    `Are you sure you want to delete this file?`
                )
            ) {
                // User wants to proceed.  Let's delete it for real
                this.deleteFile(document_id);
            }
        },

        submit: _.debounce(function() {
            let form_data = new FormData()
            let csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            form_data.append('_token', csrf);

            this.files.forEach(file => {
                form_data.append('file[]', file, file.name)
            })

            axios.post(route('documents.store'), form_data)
                .then((response)=>{
                    if (response.data.success) {
                        this.$root.snackbar.success('Documents Saved')
                        this.files=[]
                        this.getData()
                        this.dialog = false
                        // this.$set(this.request, 'id', response.data.id)
                        // location.reload()

                    } else {
                        throw (response.data.error)
                    }
                })
                .catch((error)=>{
                    this.$root.snackbar.error("Could not save documents - " + error)
                    console.log(error)
                })

        }, 666),

        cancel() {
            this.files=[]
            this.dialog = false
        }
    },
    computed: {
        headers () {
            return [
                { text: 'Filename', align: 'start', sortable: true, value: 'file_name' },
                { text: 'Type', value: 'type', sortable: true },
                { text: 'Description', value: 'description', sortable: false },
                { text: '', value: 'action', sortable: false, width: "50px", fixed:true },
            ]
        },
    },
}
</script>

<style scoped>
    .progress-bar {
        border-radius: 12px;
    }
    .file-uploader {
        padding: 8px;
    }

</style>
